module.exports = __webpack_public_path__ + "static/media/header-960.d311ac76.jpg";